import { render, staticRenderFns } from "./projectTypeForm.vue?vue&type=template&id=46f1b3d0&"
import script from "./projectTypeForm.vue?vue&type=script&lang=js&"
export * from "./projectTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports